import { css } from "@emotion/react";
import { Font, Button } from "@moneyforward/mfx_biz_react_components";
import { useRouter } from "next/router";
import { PageTitle } from "../molecules";
import { MainTemplate } from "../templates";
import config from "@/libs/config";

export const PlanStopCancelCompletedPage = () => {
  const router = useRouter();
  return (
    <MainTemplate
      title={`${config.BANK_NICKNAME} Mikatano シリーズ サービス一覧`}
    >
      <PageTitle
        mainTitle={"解約の取消し完了"}
        subTitle={
          <Font variant="l">
            解約の取消しが完了しました。
            <br />
            引き続きMikatano シリーズをご利用ください。
          </Font>
        }
      />
      <div css={button}>
        <Button
          variant="primary"
          onClick={() => router.push("/contract-management?tab=1")}
        >
          契約管理画面へ
        </Button>
      </div>
    </MainTemplate>
  );
};

const button = css({
  marginTop: "40px",
  textAlign: "center",
});
